import { observer } from 'mobx-react-lite'
import React, { useContext } from 'react'
import AdvertiserMarginField from './AdvertiserMarginField'
import PayoutPriceField from './PayoutPriceField'
import { currencyFormat } from '../../../../../../../utils/Helper'
import { CampaignContext } from '../../../../../../../contexts/CampaignContext'
import KsaSwitch from './KsaSwitch'
import ActionButtonDropdown from './MediaActionParts/ActionButtonDropdown'
import InfluencerPayoutMarginField from './InfluencerPayoutMarginField'

export default observer(function NonMediaAction({ action, campaignScenario }) {
  const { campaign } = useContext(CampaignContext)

  return (
    <tr className="dark:bg-rb-dark-mode dark:border-b dark:border-rb-dark-mode-lighter">
      <td className="p-2 text-xs align-middle font-bold dark:text-white">
        <div className="flex items-center justify-between">
          <p className="">
            {action.name}
          </p>
          <ActionButtonDropdown action={action} campaignScenario={campaignScenario} />
        </div>
      </td>
      <td className="py-2 pr-7 text-xs align-middle font-bold min-w-[100px] dark:text-white"><PayoutPriceField action={action} /></td>
      <td className="py-2 mx-6 text-xs align-middle font-bold dark:text-white">{currencyFormat(action.influencerPrice.toFixed(2), campaign.currency_symbol)}</td>
      <td className="py-2 mx-6 text-xs align-middle font-bold dark:text-white"><KsaSwitch action={action} /></td>
      <td className="py-2 mx-6 text-xs align-middle font-bold dark:text-white">{currencyFormat(action.ksaPrice.toFixed(2), campaign.currency_symbol)}</td>
      <td className="py-2 mx-6 text-xs align-middle font-bold dark:text-white">{currencyFormat(action.advertiserPrice.toFixed(2), campaign.currency_symbol)}</td>
      <td className="py-2 pr-10 text-xs align-middle font-bold min-w-[75px] dark:text-white"><InfluencerPayoutMarginField action={action} /></td>
      <td className="py-2 text-xs align-middle font-bold dark:text-white">{currencyFormat(action.influencerPayoutMarginPrice.toFixed(2), campaign.currency_symbol)}</td>
      <td className="py-2 pr-10 text-xs align-middle font-bold min-w-[75px] dark:text-white"><AdvertiserMarginField action={action} /></td>
      <td className="py-2 text-xs align-middle font-bold dark:text-white">{currencyFormat(action.advertiserMarginPrice.toFixed(2), campaign.currency_symbol)}</td>
    </tr>
  )
})